import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box } from "@mui/material";
import { ListStateIconShare } from "source/components/framework/List/ListStateIconShare";
import { Base } from "ui/Scripts/source/framework/base";

interface IRecordListFirstColumnProps {
    item: { sharedToCompanies: string[]; sharedByCompanyName: string; };
    title: string;
}

export const RecordListFirstColumn = ({ item, title }: IRecordListFirstColumnProps) => {
    return (<Box display="flex" justifyContent="space-between" flexGrow={2}>
        <Box>{title}</Box>
        {(item.sharedToCompanies.length > 0
            ? <ListStateIconShare tooltip={`${Translations.SharedTo}: ${Base.getStringWithSeparators(item.sharedToCompanies, ", ")}`} rotation={180} />
            : (item.sharedByCompanyName
                ? <ListStateIconShare tooltip={`${Translations.SharedBy}: ${item.sharedByCompanyName}`} />
                : null)
        )}
    </Box>);
};
